import { Activity, HeartPulse, ShieldCheck, LayoutDashboard } from "lucide-react";

import { SECTION_DEFINITIONS, type SectionId } from "./uiConfig";

/** Static product registry. IDs are persisted contracts; presentation stays client-side. */
export const sectionRegistry = Object.fromEntries(
  SECTION_DEFINITIONS.map((section) => [section.id, section]),
) as Record<SectionId, (typeof SECTION_DEFINITIONS)[number]>;

export const placementTargetRegistry = {
  live: {
    protection: {
      label: "Protection",
      route: "/live/campaign-schedule",
      icon: ShieldCheck,
    },
    events: { label: "Events", route: "/live/event-overview", icon: Activity },
    "system-health": {
      label: "System health",
      route: "/live/system-overview",
      icon: HeartPulse,
    },
    dashboards: { label: "Dashboards", route: "/live/dashboards", icon: LayoutDashboard },
  },
  measurement: {
    dashboards: { label: "Dashboards", route: "/measurement", icon: LayoutDashboard },
  },
};

export function isKnownPlacementTarget(sectionId: string, groupId: string | null): boolean {
  if (!(sectionId in sectionRegistry)) return false;
  if (groupId === null) return true;
  const groups = placementTargetRegistry[sectionId as keyof typeof placementTargetRegistry];
  return groups !== undefined && groupId in groups;
}
